export function constructSnippet(
  targetOpacity: number,
  isToggled: boolean
) {
  return `
<style>
  @keyframes fadeFromTransparent {
    from {
      opacity: 0;
    }
  }

  .ball {
    animation: fadeFromTransparent 1000ms;
  }
</style>

${
  isToggled
    ? `<div class="ball" style="opacity: ${targetOpacity};">`
    : ''
}
`;
}
